import { connect } from 'react-redux'
import { showAlert } from '../utils/Alert'
import {
  closeTransferModal,
} from '../actions'
import TransferModal from '../components/train_positions/TransferModal'

const mapStateToProps = state => {
  const { themeName } = state.themeReducer
  const { appVersion } = state.appVersionReducer

  return {
    themeName,
    appVersion,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    closeTransferModal: () => {
      dispatch(closeTransferModal())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransferModal)
